<template>
  <div>
    <div class="content">
      <el-table
          :data="pingramList"
          :header-cell-style="{ background: 'rgb(250,250,250)' }"
          style="width: 100%">
        <el-table-column label="摄像头点位" align="center" prop="cameraName"/>
        <el-table-column label="拍照时间" align="center" prop="timestamp">
          <template slot-scope="{ row }">
            {{ row.timestamp*1000 | dateTimeFormat('yyyy-MM-DD HH:mm:ss') }}
          </template>
        </el-table-column>
        <el-table-column label="违规类型" align="center" prop="algorithmName"/>
        <el-table-column label="照片名称" align="center" prop="alarmPicName"/>
        <el-table-column label="录像机编号" align="center" prop="cameraId"/>
        <el-table-column
            label="违规照片"
            align="center">
          <template slot-scope="{ row }">
            <img :src="row.alarmPicData" height="40" @click="openAarmPicData(row)">
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="{ row }">
            <span class="btn" style="color: #ff0000" @click="deleteBtn(row)">删除</span>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right; margin-top: 15px">
        <Page :total="total" :current="curPage" :page-size="pageSize" @on-change="pageChange"/>
      </div>
    </div>
    <Modal :title="showAlarmPicDataTile" v-model="showAlarmPicDataModal" style="width:auto">
      <div style="height:285px">
        <img :src="pingram.alarmPicData" style="height: 275px">
      </div>
    </Modal>
  </div>
</template>

<script>

import {listPingram, delPingram, getPingramById} from "@/api/pingram/pingram";

export default {
  name: 'Pingram',
  data() {
    return {
      // searchContent: '',
      pingramList: [],
      pingram: {},
      showAlarmPicDataModal: false,
      showAlarmPicDataTile: "违规抓拍",
      alarmPicData: null,
      total: 0,
      curPage: 1,
      pageSize: 10,
      open: false,
      form: {},
      rules: {},
      title: null
    }
  },
  created() {
    this.getPingramList();
  },
  methods: {
    getPingramList() {
      listPingram({limit: this.pageSize, curPage: this.curPage, type: 0, isPage: 1}).then(res => {
        this.pingramList = res.body.data
        this.total = res.body.cum
      })
    },
    pageChange(val) {
      this.curPage = val;
      this.getPingramList();
    },
    deleteBtn(row) {
      delPingram(row.id).then(res => {
        this.$message.success('删除成功')
        this.getPingramList()
      })
    },
    openAarmPicData(row) {
      this.showAlarmPicDataModal = true;
      this.showAlarmPicDataTile = "【" + row.alarmPicName + "】违规抓拍";
      getPingramById(row.id).then(response => {
        this.pingram = response.body.data
      })
    },

    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        dataID: null,
        cameraName: null,
        timestamp: null,
        alarmPicName: null,
        cameraId: null,
        alarm: null,
        alarmPicData: null
      }
    },
    /** 提交按钮 */
    /*  submitForm() {
        this.$refs['form'].validate(valid => {
          if (valid) {
            if (this.form.id != null) {
              updateBDuty(this.form).then(response => {
                this.open = false
                this.getPingramList()
              })
            } else {
              addBDuty(this.form).then(response => {
                this.open = false
                this.getPingramList()
              })
            }
          }
        })
      },*/
  }
}
</script>

<style scoped>
.head {
  display: flex;
  justify-content: space-between;
  width: calc(100% - 280px);
}

.btn {
  cursor: pointer;
}
</style>

